import * as React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as JSON from "util/json";
import Routes from "routing/Routes";
import usePluginEntities from "hooks/usePluginEntities";
import { Row, Col, Button, Input, Label } from "components/bootstrap";
import { getValueFromInput } from "util/FormsUtils";
import { lookupDataAdapter } from "components/lookup-tables/hooks/api/lookupTablesAPI";
import useScopePermissions from "hooks/useScopePermissions";
import ConfigSummaryDefinitionListWrapper from "./ConfigSummaryDefinitionListWrapper";
const DataAdapter = ({ dataAdapter, noEdit = false }) => {
  const [lookupKey, setLookupKey] = useState("");
  const [lookupResult, setLookupResult] = useState(null);
  const { loadingScopePermissions, scopePermissions } = useScopePermissions(dataAdapter);
  const navigate = useNavigate();
  const canEdit = !noEdit && !loadingScopePermissions && (scopePermissions == null ? void 0 : scopePermissions.is_mutable);
  const _onChange = (event) => {
    setLookupKey(String(getValueFromInput(event.target)));
  };
  const _lookupKey = (event) => {
    event.preventDefault();
    lookupDataAdapter(dataAdapter.name, lookupKey).then((result) => {
      setLookupResult(result);
    });
  };
  const handleEdit = () => {
    navigate(Routes.SYSTEM.LOOKUPTABLES.DATA_ADAPTERS.edit(dataAdapter.name));
  };
  const plugin = usePluginEntities("lookupTableAdapters").find(
    (p) => {
      var _a;
      return p.type === ((_a = dataAdapter.config) == null ? void 0 : _a.type);
    }
  );
  if (!plugin) {
    return /* @__PURE__ */ React.createElement("p", null, "Unknown data adapter type ", dataAdapter.config.type, ". Is the plugin missing?");
  }
  const { description: adapterDescription } = dataAdapter;
  const summary = plugin.summaryComponent;
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" } }, /* @__PURE__ */ React.createElement(Label, null, plugin.displayName), canEdit && /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: handleEdit, role: "button", name: "edit_square" }, "Edit")), /* @__PURE__ */ React.createElement(ConfigSummaryDefinitionListWrapper, null, /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, "Description"), /* @__PURE__ */ React.createElement("dd", null, adapterDescription || /* @__PURE__ */ React.createElement("em", null, "No description.")))), /* @__PURE__ */ React.createElement("hr", null), /* @__PURE__ */ React.createElement("h4", null, "Configuration"), /* @__PURE__ */ React.createElement(ConfigSummaryDefinitionListWrapper, null, React.createElement(summary, { dataAdapter })), /* @__PURE__ */ React.createElement("hr", null), /* @__PURE__ */ React.createElement("h3", null, "Test lookup"), /* @__PURE__ */ React.createElement("p", null, "You can manually trigger the data adapter using this form. The data will be not cached."), /* @__PURE__ */ React.createElement("form", { onSubmit: _lookupKey }, /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "key",
      name: "key",
      label: "Key",
      required: true,
      onChange: _onChange,
      help: "Key to look up a value for.",
      value: lookupKey
    }
  ), /* @__PURE__ */ React.createElement(Button, { type: "submit", bsStyle: "primary" }, "Look up"))), lookupResult && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h4", null, "Lookup result"), /* @__PURE__ */ React.createElement("pre", null, JSON.stringify(lookupResult, null, 2)))));
};
export default DataAdapter;
